"use client";

import * as Sentry from "@sentry/nextjs";
import NextError from "next/error";
import posthog from "posthog-js";
import { useEffect } from "react";

import { env } from "env";

const isProductionDeployment =
  env.NEXT_PUBLIC_APP_ENV === "production" || env.NEXT_PUBLIC_APP_ENV === "staging";

export default function GlobalError({ error }: { error: Error & { digest?: string } }) {
  useEffect(() => {
    console.error("global-error", error);

    if (isProductionDeployment) {
      Sentry.captureException(error);
    }

    if (isProductionDeployment && env.NEXT_PUBLIC_POSTHOG_KEY) {
      posthog.captureException(error, {
        environment: env.NEXT_PUBLIC_POSTHOG_ENVIRONMENT,
      });
    }
  }, [error]);

  return (
    <html>
      <body>
        <NextError statusCode={0} />
      </body>
    </html>
  );
}
